import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import SummaryApi from '../common'
import service from '../common/HttpService'
import { eraseCookie } from '../common/cookieHelper'

// Async Thunk for Registration
// Async Thunk for Registration
export const registerUser = createAsyncThunk(
    'user/register',
    async (data, { rejectWithValue }) => {
        try {
            const response = await service.post(SummaryApi.register.url, data)
            if (response.success === "true") {
                return response.extraData[0]
            } else {
                return rejectWithValue(response.message || "Registration failed")
            }
        } catch (error) {
            // HttpService throws an error object with response and data properties if available
            // or a standard Error object. We want a string for rejectWithValue usually.
            return rejectWithValue(error.message || "Registration failed")
        }
    }
)

// Async Thunk for Updating Profile
// Async Thunk for Updating Profile
export const updateUserProfile = createAsyncThunk(
    'user/updateProfile',
    async (data, { rejectWithValue }) => {
        try {
            const response = await service.post(SummaryApi.updateProfile.url, data)
            if (response.success === "true") {
                return response.extraData[0]
            } else {
                return rejectWithValue(response.message || "Update failed")
            }
        } catch (error) {
            return rejectWithValue(error.message || "Update failed")
        }
    }
)

// Async Thunk for Getting Profile
// Async Thunk for Getting Profile
export const viewUserProfile = createAsyncThunk(
    'user/viewProfile',
    async (_, { rejectWithValue }) => {
        try {
            const response = await service.get(SummaryApi.viewProfile.url)
            console.log("view profile===>", response)
            if (response.success === "true") {
                return response.extraData[0]
            } else {
                return rejectWithValue(response.message || "Failed to fetch profile")
            }
        } catch (error) {
            return rejectWithValue(error.message || "Failed to fetch profile")
        }
    }
)

const initialState = {
    user: null,
    loading: false,
    error: null
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserDetails: (state, action) => {
            state.user = action.payload
        },
        clearUserDetails: (state) => {
            state.user = null
            state.error = null
            eraseCookie('token')
            eraseCookie('user_id')
            localStorage.removeItem('token') // Keep for safety if transitioning? No, remove.
            localStorage.removeItem('user_id')
        }
    },
    extraReducers: (builder) => {
        builder
            // Register
            .addCase(registerUser.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(registerUser.fulfilled, (state, action) => {
                state.loading = false
                state.user = action.payload
            })
            .addCase(registerUser.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            // Update
            .addCase(updateUserProfile.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(updateUserProfile.fulfilled, (state, action) => {
                state.loading = false
                state.user = action.payload
            })
            .addCase(updateUserProfile.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            // View/Get
            .addCase(viewUserProfile.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(viewUserProfile.fulfilled, (state, action) => {
                state.loading = false
                state.user = action.payload
            })
            .addCase(viewUserProfile.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
    }
})

export const { setUserDetails, clearUserDetails } = userSlice.actions

export default userSlice.reducer